import React, { memo, useState } from 'react'
import { AiImageGenerateOption } from '../styled'
import HighlightedText from 'common-components/HighlightedText'
import * as Styled from './styled'
import { UploadArea } from 'components/UploadArea'
import { useSelector } from 'react-redux'
import AiReferenceImagesContainer from './ImagesContainer'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { replaceTranslationVariables } from 'utils/text-transformation'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { useReferenceImageUpload } from './useReferenceImageUpload'
import { SupportedFileTypesBanner } from 'common-components/SupportedFileTypesBanner'
import { useShowWarning } from './useShowWarning'

const AiImageReferenceImages: React.FC = () => {
  const refImages = useSelector(aiImageSelectors.refImages)
  const modelMaxRefImagesCount = useSelector(
    aiImageSelectors.modelMaxRefImagesCount
  )
  const availableRefImgsCount = useSelector(
    aiImageSelectors.availableRefImgsCount
  )
  const isMultipleImagesAllowed = modelMaxRefImagesCount > 1
  const [wrapperElement, setWrapperElement] = useState<HTMLDivElement | null>(
    null
  )

  const { isWarningOpen, showWarning } = useShowWarning()

  const { isFilesUploading, handleFilesUpload, handleMediaLibFiles } =
    useReferenceImageUpload(showWarning)

  const title = isMultipleImagesAllowed
    ? replaceTranslationVariables(
        translate(T.ADD_REFERENCE_MULTIPLE_IMAGES_TITLE),
        [modelMaxRefImagesCount.toString()]
      )
    : translate(T.ADD_REFERENCE_SINGLE_IMAGE_TITLE)

  return (
    <AiImageGenerateOption ref={setWrapperElement} $gap={16}>
      <Styled.CustomText type="subtitle" color="secondaryDark">
        <HighlightedText
          text={title}
          elementType="span"
          attributes={{
            className: 'highlighted'
          }}
        />
      </Styled.CustomText>
      <Styled.UploadAreaWrapper>
        {refImages?.length ? (
          <AiReferenceImagesContainer
            images={refImages}
            availableImagesCount={availableRefImgsCount}
            onAddMediaImage={handleMediaLibFiles}
            onUploadImage={handleFilesUpload}
            isUploading={isFilesUploading}
            showWarning={showWarning}
          />
        ) : (
          <UploadArea
            acceptType="image"
            wrapperRef={wrapperElement}
            multiple={isMultipleImagesAllowed}
            mediaLibConfig={{
              maxFileImportCount: availableRefImgsCount,
              fileType: 'image',
              initialFolderName: 'My_Images'
            }}
            handleFilesUpload={handleFilesUpload}
            handleMediaLibFiles={handleMediaLibFiles}
            isLoading={isFilesUploading}
            showWarning={showWarning}
          />
        )}
        <SupportedFileTypesBanner
          acceptType="image"
          isWarningOpen={isWarningOpen}
        />
      </Styled.UploadAreaWrapper>
    </AiImageGenerateOption>
  )
}

export default memo(AiImageReferenceImages)
